<template>
  <PopModal ref="modal" :title="$t('申请退款')">
    <div class="container pa-2">
      <van-form @submit="confirm">
        <div class="fw-600 fs-16 py-2 px-2">
          {{ $t("请选择申请退款的原因必选") }}
        </div>
        <template v-for="(item, index) in list">
          <div :key="index" class="px-1">
            <input
              :id="index"
              v-model="reason"
              :value="item"
              class="px-1"
              name="reason"
              required
              type="radio"
            />
            <label :for="index">&nbsp;{{ $t(item) }}</label>
          </div>
        </template>
        <van-field
          v-model="desc"
          :label="$t('留言')"
          :placeholder="$t('请输入留言')"
          autosize
          maxlength="150"
          rows="3"
          show-word-limit
          type="textarea"
        />
        <div style="margin: 16px;">
          <van-button
            :loading="loading"
            :loading-text="$t('submitting')"
            block
            native-type="submit"
            round
            small
            type="primary"
          >
            {{ $t("submit") }}
          </van-button>
        </div>
      </van-form>
    </div>
  </PopModal>
</template>
<script>
import PopModal from "@/components/PopModal.vue";

export default {
  props: {
    no: String
  },
  components: {
    PopModal
  },
  data() {
    return {
      desc: "",
      reason: "",
      loading: false,
      list: [
        "退款原因_拍错_多拍_不喜欢",
        "退款原因_商品成分描述不符",
        "退款原因_与商家协商一致退款",
        "退款原因_生产日期_保质期与商品描述不符",
        "退款原因_图片_产地_批号_规格等描述不符",
        "退款原因_质量问题",
        "退款原因_商品变质_发霉_有异物",
        "退款原因_少件_含缺少配件_",
        "退款原因_收到商品时有破损_污渍_变形",
        "退款原因_假冒品牌",
        "退款原因_发票问题",
        "退款原因_商家发错货",
        "退款原因_预约不到_商家不给退换"
      ]
    };
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    confirm() {
      this.loading = true;
      this.$post("/user/goodsOrder/applyRefund", {
        no: this.no,
        refundBuyerDesc: this.$t(this.desc),
        refundBuyerSelectReason: this.$t(this.reason),
      }).finally(() => {
        this.loading = false;
        this.$refs.modal.hide();
        this.$emit("confirm");
      });
    }
  }
};
</script>
